﻿'use strict';

angular.module('ntmApp').factory('ListGridSettings', ['Utils', 'ListGridGrouping', 'ListGridDragging', 'ListGridPaging', 'ListGridMultiselect', 'ListGridConditions', 'ListGridPreferences',
    function (Utils, ListGridGrouping, ListGridDragging, ListGridPaging, ListGridMultiselect, ListGridConditions, ListGridPreferences) {

    function ListGridSettings(settings, preferences) {

        var self = this;

        settings = !Utils.IsTypeheadEmpty(settings) ? JSON.parse(settings) : {};
        preferences = !Utils.IsTypeheadEmpty(preferences) ? JSON.parse(preferences) : {};

        self.grouping = new ListGridGrouping(settings.grouping);
        self.dragging = new ListGridDragging(settings.dragging);
        self.paging = new ListGridPaging(settings.paging);
        self.conditions = new ListGridConditions(settings.conditionalData);
        self.preferences = new ListGridPreferences(preferences);
        self.multiselect = new ListGridMultiselect(settings.multiselect);

        self.maxWidth = settings.maxWidth ? settings.maxWidth + 'px' : 'none';

    }

    return (ListGridSettings);
}]);